module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/truora-badge-59aa60cccd285e8270fbbf8c3f64291b.svg";